export default __webpack_public_path__ + "static/media/step4-7.7d43ce3f.jpg";